import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { LdsUserService } from '../../services/lds-user.service';
import { EnergyDataService } from '../../energy-data/energy-data.service';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { TimeSelectComponent } from '../../time-select/time-select.component';
import { EnergyTotalByCategory, FeatureSetsData, RoomData } from '../../interfaces/data-analytics';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'lds-energy-overview',
    templateUrl: './energy-overview.component.html',
    styleUrls: ['./energy-overview.component.css'],
    standalone: false
})
export class EnergyOverviewComponent implements OnInit, OnDestroy {
  private isDestroyed = false

  constructor(public user: LdsUserService, private energyData: EnergyDataService, private eb: LdsEventBusService, 
    private http: HttpClient, private dialog: MatDialog) { }

  public timespan = 'weekly';
  public graphType = 'bar';

  rooms: (RoomData & {featureSetsWithData: number, homeName: string, linkId: string})[] = []
  multipleStructures = false

  @ViewChild('graph', { static: false }) graphArea: ElementRef;
  graph: any;

  async ngOnInit() {
    this.user.currentModule = 'Energy Overview';

    this.rooms = this.user.rooms.concat().map(e => Object.assign({ featureSetsWithData: 0, homeName: '', linkId: '' }, e))
    this.rooms.sort((a,b) => {
      if (a.name > b.name) return 1
      if (a.name < b.name) return -1
      return 0
    })

    this.eb.subscribe('energySummary-featureSets-loaded', (data) => {
      if (this.isDestroyed) return
      if (data) {
        // Build a Map for O(1) lookups instead of O(n) find() calls
        const featureSetMap = new Map(
          this.energyData.featureSetsWithData.map(fs => [fs.groupId, fs])
        )

        // add additional details to rooms, eg count of featureSets with data
        let seenStructures = {}
        this.rooms.forEach(room => {
          const home = this.user.getHome(room.groupId)
          if (home) {
            room.linkId = home.linkId
            seenStructures[home.structureId] = true
            if (home.name !== 'default home') room.homeName = home.name
          }
    
          // Use Map for O(1) lookup instead of find()
          room.featureSetsWithData = room.featureSets.filter(
            featureSetId => featureSetMap.has(featureSetId)
          ).length
        })

        if (Object.keys(seenStructures).length > 1) this.multipleStructures = true
      }  
    })
  }

  ngOnDestroy() {
    this.isDestroyed = true
    this.eb.clearEvent('energy-featureSet-loaded')
    this.eb.clearEvent('energySummary-featureSets-loaded')
  }


  changeGraphType(graphType){
    this.graphType = graphType;
  }

  buttonClicked(room) {
    if (room === 'all_rooms') {
      this.energyData.featureSetsWithData.forEach(featureSet => {
        featureSet.selected = true;
      })
      this.eb.broadcast('energy-featureSets-updated');
    } else {
      room.selected = true;
      let featureSetList = room.featureSets;

      for (let index = 0; index < this.energyData.featureSetsWithData.length; index++) {
        const element = this.energyData.featureSetsWithData[index];

        if (featureSetList.indexOf(element.groupId) === -1) {
          element.selected = false;
        } else {
          element.selected = true;
        }
      }
      this.eb.broadcast('energy-featureSets-updated');
    }
  }

  async changeTimeSpan(value) {
    if (value !== "custom") {
      this.timespan = value;
      this.eb.broadcast("overview-timespan-change", { timespan: value });
      return;
    }

    this.dialog.open(TimeSelectComponent).afterClosed().subscribe(res => {
      if (!res.timeSelected) return;
      if (!res.startDate || !res.endDate) return;

      this.timespan = "custom";
      this.eb.broadcast("overview-timespan-change", { timespan: value, startDate: res.startDate, endDate: res.endDate});

    })
  }
}



